import type {
  RecruitmentTag as RecruitmentTagType,
  RecruitmentType,
} from '../../../../../core/entities/recruitment/schema';
import {
  RecruitmentJobTypeTag,
  RecruitmentTagListItem,
  RecruitmentTargetYearTag,
  RecruitmentTypeListItem,
} from '../../RecruitmentTag';

type Props = {
  title: string;
  recruitmentType: RecruitmentType;
  targetYear: number;
  groupedJobTypes: Array<{id: number; name: string}>;
  tags: RecruitmentTagType[];
};

export const RecruitmentTitle: React.FC<Props> = ({
  title,
  recruitmentType,
  targetYear,
  groupedJobTypes,
  tags,
}) => {
  return (
    <div className="bg-white pc:border-t-4 pc:border-collapse pc:border-primary-1 p-16 pc:p-24">
      <div className="flex justify-start items-start flex-wrap mb-4">
        {recruitmentType && (
          <div className="mb-4 mr-8">
            <RecruitmentTypeListItem recruitmentType={recruitmentType} />
          </div>
        )}
        <div className="mb-4 mr-8">
          <RecruitmentTargetYearTag
            label={targetYear ? `${targetYear}年卒` : '卒年不問'}
          />
        </div>
        {groupedJobTypes.map((jobType) => {
          return (
            <div className="mb-4 mr-8">
              <RecruitmentJobTypeTag jobType={jobType} />
            </div>
          );
        })}
        {tags.map((tag) => {
          return (
            <div className="mb-4 mr-8">
              <RecruitmentTagListItem recruitmentTag={tag} />
            </div>
          );
        })}
      </div>
      <h1 className="text-primary-1 text-lg leading font-bold">{title}</h1>
    </div>
  );
};
